let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8S0iX")).then(() => parcelRequire('3RQQj'));